import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, input, InputSignal, output, signal } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { InterestList } from '../../../../interfaces/edit-route.response';

@Component({
  selector: 'interest-filter',
  standalone: true,
  imports: [
    TranslateModule,
  ],
  templateUrl: './interest-filter.component.html',
  styleUrls: ['./interest-filter.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class InterestFilterComponent {
    public interestList: InputSignal<InterestList[]> = input.required<InterestList[]>();
    public interestsIdsChange = output<number[]>();
    public translate = inject(TranslateService);

    handleSelectedInterest(event){
        const selectedRouteDayValue = event?.detail?.values; 
        this.interestsIdsChange.emit(selectedRouteDayValue);
    }
}